import { PhotoCapture } from '../enums';
const MODULE_PREFIX = PhotoCapture.PHOTO_CAPTURE;
export const PHOTO_CAPTURE_GET_CONTEXT_DATA_REQUEST = `${MODULE_PREFIX}_GET_CONTEXT_DATA_REQUEST`;
export const PHOTO_CAPTURE_GET_CONTEXT_DATA_SUCCESS = `${MODULE_PREFIX}_GET_CONTEXT_DATA_SUCCESS`;
export const photoCaptureGetContextDataAction = (coCode, contextId) => ({
    type: PHOTO_CAPTURE_GET_CONTEXT_DATA_REQUEST,
    payload: { coCode, contextId }
});
export const photoCaptureGetContextDataSuccessAction = photoCaptureContextData => ({
    type: PHOTO_CAPTURE_GET_CONTEXT_DATA_SUCCESS,
    payload: { photoCaptureContextData }
});
//# sourceMappingURL=photoCaptureGetContextAction.js.map